import { IssuesTab } from "@/organisms/Drawers/components/IssuesTab"
import {
  getDefaultFiltersInventoryImageIssuesDrawer,
  getDefaultParamsOpenSourceIssue
} from "@/organisms/Drawers/hooks/useParamsFilter"

import { buildQueryStringFromRecord } from "@/helpers/filters.helper"
import type { IssuesTabImageDrawerComponent } from "."

export const IssuesTabImageDrawer: IssuesTabImageDrawerComponent = (props) => {
  return (
    <IssuesTab
      getInitialParamsFilter={getDefaultFiltersInventoryImageIssuesDrawer}
      defaultParams={getDefaultParamsOpenSourceIssue()}
      includeApplicationFilter
      exportQueryParams={(params: Record<string, any>) =>
        buildQueryStringFromRecord({ resourceId: props.record?.id, ...params })
      }
      {...props}
    />
  )
}
